import { UPDATE_CUSTOMER } from "./api-url.constants";
import { UpdateCustomerApiDto } from "./dtos";
import { API_METHODS } from "../shared";
import { UpdateCustomerError, AvantioIntegrationError } from "./errors";
import { typedFetch } from "@/lib/helpers";

export const updateCustomer = async (customer: UpdateCustomerApiDto): Promise<boolean> => {
  const { _id, ...body } = customer;

  const result = await typedFetch(`${UPDATE_CUSTOMER}/${_id}`, {
    method: API_METHODS.PUT,
    body: JSON.stringify(body),
  });

  if (!result.ok) {
    // Try to get error details from response
    try {
      const errorData = await result.json();

      // Check if it's an Avantio integration error
      if (
        errorData?.error?.includes("Avantio Integration") ||
        errorData?.message?.includes("Avantio integration failed")
      ) {
        throw new AvantioIntegrationError(
          errorData.message ||
            "Failed to configure Avantio integration. Please verify your API key."
        );
      }
    } catch (parseError) {
      // If we can't parse the error, fall back to generic error
    }

    throw new UpdateCustomerError();
  }

  return true;
};
